import React from 'react';

import { INSTANCE } from '@lumapps/instance/keys';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiSettings } from '@lumapps/lumx/icons';
import { useTranslate, GLOBAL } from '@lumapps/translations';

import {
    INSTANCE_ADVANCED_SETTINGS_ALL_PAGE_KEYS,
    INSTANCE_GLOBAL_SETTINGS_ALL_PAGE_KEYS,
    ADVANCED_SETTINGS_PAGE_ID,
    SETTINGS_PAGE_ID,
} from '../../constants';
import { instanceSettingsRoute, instanceAdvancedSettingsRoute } from '../../routes';

export interface InstanceSettingsSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const InstanceSettingsSideNavigation = ({ isAllowed, ...restOfProps }: InstanceSettingsSideNavigationProps) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(INSTANCE.INSTANCE_SETTINGS)}
            icon={mdiSettings}
            id="instance-settings"
        >
            <SideNavigationItem
                label={translateKey(GLOBAL.GLOBAL_SETTINGS)}
                route={instanceSettingsRoute}
                id={SETTINGS_PAGE_ID}
                pageKeys={INSTANCE_GLOBAL_SETTINGS_ALL_PAGE_KEYS}
            />
            <SideNavigationItem
                label={translateKey(GLOBAL.ADVANCED_SETTINGS)}
                route={instanceAdvancedSettingsRoute}
                id={ADVANCED_SETTINGS_PAGE_ID}
                pageKeys={INSTANCE_ADVANCED_SETTINGS_ALL_PAGE_KEYS}
            />
        </SideNavigationItem>
    );
};

InstanceSettingsSideNavigation.displayName = 'SideNavigationItem';

export { InstanceSettingsSideNavigation };
